module.exports = __webpack_public_path__ + "img/icons8-search-128.76814216.png";